<template>
  <span>
    <i class="fa-light fa-tags pulsante_comando" @click="openModal()" style="padding: 8px" v-if="showButton" />
    <div
      aria-labelledby="modalTags"
      :id="`tag_modal_${this.resource}_${this.id}`"
      class="modal tags-popup"
      role="dialog"
      v-show="isModalVisible"
    >
      <header class="modal-header">
        <i class="fa-light fa-tags fa-2x" />
        <h3 class="title">TAG</h3>
        <button type="button" class="btn-close" @click="close" aria-label="Close modal">
          <i class="fa-light fa-xmark"></i>
        </button>
      </header>
      <div class="modal-body">
        <v-select2
          v-model="new_tags"
          :id="`tags-select-${id}`"
          :idAttr="'id'"
          :options-list="tag_options"
          :multiple="true"
          :selectConfig="selectConfig"
        />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="saveTags" aria-label="Save modal">
          {{ i18nJS.command.save }}
        </button>
      </div>
    </div>
  </span>
</template>

<script>
import axios from 'axios';
import vSelect2 from '../vSelect2';

export default {
  name: 'add_tag',
  computed: {
    saveTagUrl() {
      return `/${window.locale}/business_units/${this.$attrs.business_unit_id}/tags/${this.resource}/${this.id}.json`;
    },
    allTagsUrl() {
      return `/${window.locale}/business_units/${this.business_unit_id}/tags/${this.resource}.json`;
    },
    optionUrl() {
      return `${this.allTagsUrl}?sel`;
    },
    selectConfig() {
      return {
        placeholder: `${window.i18nJS.activity.selectEl}`,
        url: `${this.allTagsUrl}?sel`,
        processResults: this.processResults,
      };
    },
    i18nJS() {
      return window.i18nJS;
    },
  },
  data() {
    return {
      firstModalOpen: true,
      isModalVisible: false,
      new_tags: [],
    };
  },
  props: ['id', 'resource', 'tags', 'tag_options', 'showButton'],
  components: {
    vSelect2,
  },
  mounted() {
    this.tags.forEach((ele) => this.new_tags.push(ele));
    eventBus.$on('editTag', this.handleEditTag);
  },
  methods: {
    close() {
      this.isModalVisible = false;
    },
    handleEditTag(event) {
      if (this.id == event.id && this.resource == event.resource) {
        this.openModal();
      }
    },
    openModal() {
      this.isModalVisible = true;
      if (this.firstModalOpen) {
        $(`#tags-select-${this.id}`).trigger('change');
        this.firstModalOpen = false;
      }
    },
    processResults(data) {
      if (data) {
        return {
          results: data.map((res) => {
            return { text: res.label, id: res.id };
          }),
          pagination: {
            more: data.length === 30,
          },
        };
      } else {
        return {};
      }
    },
    calcHashDelta(oldTags, newTags) {
      let removingTagIds = oldTags.filter((x) => !newTags.includes(x));
      let addingTagIds = newTags.filter((x) => !oldTags.includes(x));

      return { add: addingTagIds, remove: removingTagIds };
    },
    saveTags() {
      const oldTags = [...this.tags].map((tag) => {
        return tag.id;
      });
      this.new_tags = this.new_tags || [];
      if (this.new_tags != this.tags) {
        axios({
          method: 'post',
          url: this.saveTagUrl,
          data: { tags: this.new_tags.length ? this.new_tags : [0] },
          headers: {
            'Content-type': 'application/json',
            'X-CSRF-Token': $.rails.csrfToken(),
          },
        })
          .then((res) => {
            this.isModalVisible = false;
            $(`#tag-list-${this.id}`).html('');

            const tags_opts = this.tag_options.filter((el) => {
              return this.new_tags.includes(el[1]);
            });
            const new_tags_html = tags_opts.map((tag) => {
              return `<div class="badge badge-info adv-tag" style="background-color: ${tag[3] || '#3a87ad'};"><i class="fa-light ${tag[2] || 'fa-tag'}"></i><span data-id="${tag[1]}">${tag[0]}</span></div>`;
            });
            $(`div[id="tag-list-${this.id}"]:visible`).html(new_tags_html);
            eventBus.$emit('tagUpdated', {
              id: this.id,
              resource: this.resource,
              tags: tags_opts.map((arr) => {
                return { id: arr[1], cod: arr[0], fillcolor: arr[3], faicon: arr[2] };
              }),
            });
            eventBus.$emit('tags_count_changes', this.calcHashDelta(oldTags, this.new_tags));
          })
          .catch((err) => {
            var msg = `${i18nJS.errors.critical_error}: ${err.message}`;
            if (err.response && err.response.status === 401) {
              msg = i18nJS.access_denied;
            }
            this.isModalVisible = false;
            Utils.appendToFlash('error', msg);
          });
      } else {
        this.isModalVisible = false;
      }
    },
  },
};
</script>

<style lang="scss">
[aria-labelledby='modalTags'] .select2-search__field {
  width: inherit !important;
}
</style>
<style lang="scss" scoped>
.modal-body {
  display: flex;
  justify-content: center;
  margin: 0 0 1em;

  & > .select2-container {
    width: 300px;
  }
}
.btn-close {
  background: inherit;
  border: 0;
}
.modal-header {
  display: flex;
  height: 2.5em;
  justify-content: space-between;
}
.node-controls {
  display: flex;
  & .fa-light {
    margin: 5px;
  }
}
</style>
